var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5D5C5C",
    fillRule: "nonzero",
    stroke: "#7C7C7C",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 13.034A6.034 6.034 0 1 1 8 1.966a6.034 6.034 0 0 1 0 12.068Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.138 8.517H8.483v-3.62a.483.483 0 0 0-.966 0V9c0 .267.216.483.483.483h3.138a.483.483 0 1 0 0-.966Z"
  }))));
};
export default SvgTime;